'use strict';

import Analytics from '../../_common/js/modules/analytics';
import announcementBar from '../../_common/js/modules/announcement';
import popupButtons from '../../_common/js/modules/popupButtons';
import Cookies from '../../_common/js/modules/cookies';
import imageWrapper from '../../_common/js/modules/imageWrapper';
import intlPhoneInput from '../../_common/js/modules/intlPhoneInput';
import mediumZoom from '../../_common/js/modules/mediumZoom';
import platformSelector from '../../_common/js/modules/platformSelector';
import tabsHoverAction from './modules/tabsHover';
import contactForm from '../../_common/js/modules/contactForm';
import gdprCookie from '../../_common/js/modules/gdprCookie';
import stickyMainMenu from '../../_common/js/modules/stickyMainMenu';
import themeCountdown from '../../_common/js/modules/themeCountdown';

( function( document, window ) {
    const analytics = Analytics();
    const cookiesGeneral = Cookies( 'HDM' );

    // Ready
    document.addEventListener( 'DOMContentLoaded', function() {
        stickyMainMenu();
        mediumZoom();

        const zoomWrap = document.querySelector( '.zoom-default:not([hidden]' );
        if ( zoomWrap ) {
            imageWrapper();
        }

        tabsHoverAction();

        const phoneInputs = document.querySelectorAll( 'input[type=tel]' );
        if ( phoneInputs.length ) {
            intlPhoneInput( phoneInputs );
        }

        const chatBtn = document.querySelector( '.zendesk-btn' );
        const wizardBtn = document.querySelector( '.wizard-caption-btn' );
        const calendlyBtn = document.querySelector( '.calendly-btn' );
        if ( chatBtn || wizardBtn || calendlyBtn ) {
            popupButtons();
        }

        const platformList = document.querySelector( '.platform-list' );
        if ( platformList ) {
            platformSelector( cookiesGeneral );
        }

        const announcementBarElement = document.querySelector( '.announcement-bar' );
        if ( announcementBarElement ) {
            announcementBar( cookiesGeneral, announcementBarElement );
        }

        const gdprCookieElement = document.getElementById( 'tuna_gdpr__cookie' );
        if ( gdprCookieElement ) {
            gdprCookie( cookiesGeneral, gdprCookieElement );
        }

        const wpcf7Form = document.querySelector( '.wpcf7-form' );
        if ( wpcf7Form ) {
            contactForm();
        }

        const themeCountdownItem = document.querySelector( '#theme-countdown' );
        if ( themeCountdownItem ) {
            themeCountdown();
        }
    } );
}( document, window ) );
